import { ApiAxiosInstance } from './types';

/**
 * Base class for all our api classes
 */
export default class BaseApiClient {
  protected client: ApiAxiosInstance;

  constructor(client: ApiAxiosInstance) {
    this.client = client;
    return this;
  }
}
